import React from "react"
import {breakpoints} from "@next/ux-fabric"
import connect from "./connect"

type HeaderHeightProps = {
    mobileHeight: number
    desktopHeight: number
    mobileScrollHeight: number
}

// TODO: Remove the header.PageHeader:not section as part of a tech debt peice 49182
// This is here as a hotfix to allow Vision header and EPM plp work together
export const HeaderHeightStyles = ({mobileHeight, desktopHeight, mobileScrollHeight}: HeaderHeightProps) => {
    return (
        <style>
            {`
              [data-container-page] {
                margin-top: calc(${mobileHeight}rem + var(--next-header-branchio-height, 0px));
              }

              @media (min-width: ${breakpoints.values.md}px) {
                [data-container-page] {
                  margin-top: calc(${desktopHeight}rem + var(--next-header-branchio-height, 0px));
                }
              }

              :root {
                --next-header-branchio-height: 0rem;
                --next-header-height: calc(${mobileHeight}rem + var(--next-header-branchio-height, 0px));
                --next-header-md-height: calc(${desktopHeight}rem + var(--next-header-branchio-height, 0px));
                --next-header-lg-height: calc(${desktopHeight}rem + var(--next-header-branchio-height, 0px));
                --next-header-scroll-height: ${mobileScrollHeight}rem;
              }

              body header.PageHeader:not(.SecurePageHeader) .BreadcrumbNavigation {
                margin-top: 0px;
              }
            `}
        </style>
    )
}

export default connect(HeaderHeightStyles)
